let notificationAudio = null;

/**
 * Play schoolbell sound for incoming notifications (web).
 */
export function playNotificationSound() {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        if (!notificationAudio) {
            notificationAudio = new Audio(`${process.env.PUBLIC_URL || ''}/sounds/schoolbell.mp3`);
            notificationAudio.preload = 'auto';
        }
        notificationAudio.currentTime = 0;
        const playPromise = notificationAudio.play();
        if (playPromise?.catch) {
            playPromise.catch(() => {});
        }
    } catch {
        // Ignore autoplay restrictions
    }
}
